class MoLocalStorage implements Pick<Storage, 'getItem' | 'setItem' | 'removeItem'> {
  getItem(key: string): string | null {
    try {
      return localStorage.getItem(key);
    } catch {
      return null;
    }
  }

  setItem(key: string, value: string): void {
    try {
      localStorage.setItem(key, value);
    } catch {
      // Best-effort: the browser denied storage access or the quota is full.
    }
  }

  removeItem(key: string): void {
    try {
      localStorage.removeItem(key);
    } catch {
      // Best-effort: the browser denied storage access.
    }
  }
}

export const moLocalStorage = new MoLocalStorage();
